import { WorkloadFetch } from '@/pages/clusters/pages/Workload/constants';
import { getLoginType } from '@/pages/login-page/service';
import { useEffect, useState } from 'react';
import useSWR from 'swr';

interface GpuOptionsConfigs {
  // 筛选平台, 默认是全部
  platform?: 'CLOUD' | 'CONTAINER';
}

export const useGpuOptions = ({ platform }: GpuOptionsConfigs = {}) => {
  const [gpuOptions, setGpuOptions] = useState<{ label: string; value: string }[]>([]);
  const { data: response } = useSWR({ key: WorkloadFetch.GPU_OPTIONS }, () => getLoginType());

  useEffect(() => {
    if (response) {
      if (Array.isArray(response.GpuKinds)) {
        const options = response.GpuKinds.filter((item) => item.resourceType === 'GPU')
          .filter((item) => {
            if (platform) {
              return item.platform === platform;
            }
            return true;
          })
          .map((item) => ({
            label: item.name,
            value: item.resourceName,
          }));
        setGpuOptions(options);
      }
    }
  }, [response, platform]);

  return { gpuOptions };
};
